import React from 'react'
import { useTranslation } from 'react-i18next'

import { Share } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'

import { useCopyToClipboard } from '../../hooks/useCopyToClipboard'
import analyticsService from '../../services/AnalyticsService'
import { AnalyticsProviders } from '../../types/IAnalyticsProvider'
import './ShareUrlButton.scss'

type ShareUrlButtonProps = ButtonProps & {
  trackingId?: string
  label?: string
}

const ShareUrlButton: React.FC<ShareUrlButtonProps> = ({ label, trackingId, className, ...buttonProps }) => {
  const { t } = useTranslation()
  const copyToClipboard = useCopyToClipboard()
  const buttonLabel = !label ? t('common:share_button_label') : label

  const copyUrlToClipboard = () => {
    copyToClipboard(window.location.href)

    if (trackingId) {
      analyticsService.trackEvent('Share Button', {
        data: { shareId: trackingId },
        serviceToExclude: [AnalyticsProviders.intercom, AnalyticsProviders.hubspot],
      })
    }
  }

  // `variant`/`color` are overridable defaults: pass e.g. variant="outlined" for a
  // non-filled share button. `startIcon`/`onClick` stay fixed (they are the button's purpose).
  return (
    <Button
      variant="contained"
      color="primary"
      {...buttonProps}
      startIcon={<Share />}
      onClick={copyUrlToClipboard}
      className={['ShareUrlButton', className].filter(Boolean).join(' ')}
    >
      {buttonLabel}
    </Button>
  )
}

export default ShareUrlButton
